import { Container, CustomDivider } from "components";
import { InputFormField } from "components/hookForm";
import Typograph from "components/typograph";
import { paymentMethods } from "constants/paymentMethods";
import { DropdownOptions, IWebReceivablePaymentData } from "interfaces";
import { ICustomLabels } from "interfaces/IWhitelabelConfigurationResponse";
import LossDraftComponent from "pages/receivables/partial/transactionForm/steps/transactionDetails/paymentTypes/lossDraft";
import styles from "pages/receivables/partial/transactionForm/steps/transactionDetails/transactionDetails.module.scss";
import { useFormContext } from "react-hook-form";
import { amountIsValid } from "tools/validators";
import { electronicPaymentAmountLimitInDollars } from "pages/receivables/partial/transactionForm/steps/authorizePayment/authorizePayment";

interface NglsDetailsFormProps {
  paymentData: IWebReceivablePaymentData;
  statesOptions?: DropdownOptions[];
  customLabels?: ICustomLabels;
}

// NGLS borrower details. Kept separate from the standard transaction form so this flow can change on its own.
const NglsDetailsForm: React.FC<NglsDetailsFormProps> = (props) => {
  const { paymentData, statesOptions, customLabels } = props;
  const { getValues, watch } = useFormContext();
  const amountValue = watch("amount", "");

  return (
    <Container className={styles.transactionDetailContainer}>
      <LossDraftComponent
        statesOptions={statesOptions}
        customLabels={customLabels}
        companyId={paymentData.companyId}
        ngls
      />
      <CustomDivider title="Check amount" />
      <Container className={styles.singleInputContainer}>
        <InputFormField
          name="amount"
          label="Check amount"
          maxLength={13}
          defaultValue={getValues("amount") ? getValues("amount") : "0"}
          currency={true}
          validate={(textFieldValue: string) => amountIsValid(textFieldValue)}
          disabled={paymentData.paymentRequested ? true : false}
          required
        />
      </Container>
      {parseInt(amountValue) > electronicPaymentAmountLimitInDollars &&
        paymentData.availablePaymentMethods.some(
          (method) => method.id === paymentMethods.ELECTRONIC_PAYMENT
        ) &&
        !paymentData.availablePaymentMethods.some(
          (method) => method.id === paymentMethods.CHECK_CAPTURE
        ) && (
          <Typograph
            color="#F9635E"
            content={`Payment amount exceeds the ACH limit of $10,000.00. Please split this transaction into smaller payments or contact ${paymentData.companyName}`}
          />
        )}
    </Container>
  );
};

export default NglsDetailsForm;
